module.exports = __webpack_public_path__ + "media/images/not_found_400-1346876847e98cf1907dc1401e729202.svg";